import { type } from "../types/types";

export const set_variants = (variants) => (dispatch) => {
  dispatch({
    type: type.SET_VARIANTS,
    variants: variants,
  });
};

export const set_variant_detail = (variantDetail) => (dispatch) => {
  dispatch({
    type: type.SET_VARIANT_DETAIL,
    variantDetail: variantDetail,
  });
};
